import {
  Link,
  sidebarConfig,
  useSidebarOpenState,
} from '@backstage/core-components';
import { Box, makeStyles, Typography } from '@material-ui/core';
import {
  UserSettingsSignInAvatar,
  useUserProfile,
} from '@backstage/plugin-user-settings';

const useStyles = makeStyles(theme => ({
  link: {
    color: theme.palette.navigation.color,
    display: 'flex',
    alignItems: 'center',
    height: 64,
    overflow: 'hidden',
    width: '100%',
    '&:hover': {
      background:
        theme.palette.navigation.navItem?.hoverBackground ?? '#404040',
    },
  },
  avatar: {
    alignItems: 'center',
    display: 'flex',
    flex: `0 0 ${sidebarConfig.drawerWidthClosed}px`,
    justifyContent: 'center',
  },
  details: {
    minWidth: 0,
    paddingRight: theme.spacing(2),
  },
  displayName: {
    color: 'inherit',
    fontWeight: 600,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  metadata: {
    color: 'inherit',
    opacity: 0.72,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}));

export function metadataNameFromEntityRef(entityRef?: string): string {
  if (!entityRef) return 'unknown';
  const slashIndex = entityRef.lastIndexOf('/');
  return slashIndex >= 0 ? entityRef.slice(slashIndex + 1) : entityRef;
}

export function SidebarUserAccount() {
  const classes = useStyles();
  const { isOpen } = useSidebarOpenState();
  const { backstageIdentity, displayName, loading } = useUserProfile();
  const metadataName = metadataNameFromEntityRef(
    backstageIdentity?.userEntityRef,
  );
  const resolvedDisplayName =
    displayName || (loading ? 'Loading account…' : metadataName);

  return (
    <Link
      to="/settings"
      underline="none"
      className={classes.link}
      aria-label={`${resolvedDisplayName}, metadata.name ${metadataName}`}
    >
      <Box className={classes.avatar}>
        <UserSettingsSignInAvatar size={36} />
      </Box>
      {isOpen ? (
        <Box className={classes.details}>
          <Typography variant="body2" className={classes.displayName}>
            {resolvedDisplayName}
          </Typography>
          <Typography variant="caption" className={classes.metadata}>
            metadata.name: {metadataName}
          </Typography>
        </Box>
      ) : null}
    </Link>
  );
}
